module.exports = __webpack_public_path__ + "static/media/red-pay-logo.d781f20b.png";